import { render, staticRenderFns } from "./ItemChipsWithMoreCustom.vue?vue&type=template&id=d93fb868"
import script from "./ItemChipsWithMoreCustom.vue?vue&type=script&lang=ts"
export * from "./ItemChipsWithMoreCustom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d93fb868')) {
      api.createRecord('d93fb868', component.options)
    } else {
      api.reload('d93fb868', component.options)
    }
    module.hot.accept("./ItemChipsWithMoreCustom.vue?vue&type=template&id=d93fb868", function () {
      api.rerender('d93fb868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ItemChipsWithMoreCustom.vue"
export default component.exports